const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

function createRequestTypes(base) {
    const res = {};
    [REQUEST, SUCCESS, FAILURE].forEach(type => res[type] = `${base}_${type}`);
    return res;
}

function action(type, data = {}, section = undefined) {
    return {
        type,
        data,
        section
    };
}

export const LIVE_INIT = createRequestTypes('LIVE_INIT');
export const LIVE_UPDATE = createRequestTypes('LIVE_UPDATE');

export const TIMETABLE_INIT = createRequestTypes('TIMETABLE_INIT');
export const TIMETABLE_UPDATE = createRequestTypes('TIMETABLE_UPDATE');

export const GET_BALANCE = createRequestTypes('GET_BALANCE');
export const GET_NEW_MESSAGES = createRequestTypes('GET_NEW_MESSAGES');
export const GET_FREEBET = createRequestTypes('GET_FREEBET');

export const GET_BET_STATUS = createRequestTypes('GET_BET_STATUS');
export const GET_STAKE_STATUS = createRequestTypes('GET_STAKE_STATUS');
export const GET_CASHOUT_STATUS = createRequestTypes('GET_CASHOUT_STATUS');

export const sagaActions = {
    live_initial: {
        request: (data) => action(LIVE_INIT.REQUEST, {languageId: data.languageId}, 'live'),
        success: (data) => action(LIVE_INIT.SUCCESS, data, 'live'),
        failure: (data, error) => action(LIVE_INIT.FAILURE, {languageId: data.languageId, error}, 'live')
    },
    live_update: {
        request: (data) => action(LIVE_UPDATE.REQUEST, {languageId: data.languageId, version: data.version}, 'live'),
        success: (data) => action(LIVE_UPDATE.SUCCESS, data, 'live'),
        failure: (data, error) => action(LIVE_UPDATE.FAILURE, {languageId: data.languageId, version: data.version, error}, 'live')
    },
    timetable_initial: {
        request: (data) => action(TIMETABLE_INIT.REQUEST, {languageId: data.languageId}, 'timetable'),
        success: (data) => action(TIMETABLE_INIT.SUCCESS, data, 'timetable'),
        failure: (data, error) => action(TIMETABLE_INIT.FAILURE, {languageId: data.languageId, error}, 'timetable')
    },
    timetable_update: {
        request: (data) => action(TIMETABLE_UPDATE.REQUEST, {languageId: data.languageId, version: data.version}, 'timetable'),
        success: (data) => action(TIMETABLE_UPDATE.SUCCESS, data, 'timetable'),
        failure: (data, error) => action(TIMETABLE_UPDATE.FAILURE, {languageId: data.languageId, version: data.version, error}, 'timetable')
    },
    get_balance: {
        request: (data) => action(GET_BALANCE.REQUEST, data),
        success: (data) => action(GET_BALANCE.SUCCESS, data),
        failure: () => action(GET_BALANCE.FAILURE)
    },
    get_new_messages: {
        request: () => action(GET_NEW_MESSAGES.REQUEST),
        success: (data) => action(GET_NEW_MESSAGES.SUCCESS, data),
        failure: () => action(GET_NEW_MESSAGES.FAILURE)
    },
    get_freebet: {
        request: () => action(GET_FREEBET.REQUEST),
        success: (data) => action(GET_FREEBET.SUCCESS, data),
        failure: () => action(GET_FREEBET.FAILURE)
    },
    get_bet_status: {
        request: (data) => action(GET_BET_STATUS.REQUEST, data),
        success: (data) => action(GET_BET_STATUS.SUCCESS, data),
        failure: (data) => action(GET_BET_STATUS.FAILURE, data)
    },
    get_stake_status: {
        request: (data) => action(GET_STAKE_STATUS.REQUEST, data),
        success: (data) => action(GET_STAKE_STATUS.SUCCESS, data),
        failure: (data) => action(GET_STAKE_STATUS.FAILURE, data)
    },
    get_cashout_status: {
        request: (data) => action(GET_CASHOUT_STATUS.REQUEST, data),
        success: (data) => action(GET_CASHOUT_STATUS.SUCCESS, data),
        failure: (data) => action(GET_CASHOUT_STATUS.FAILURE, data)
    }
};



// WEBPACK FOOTER //
// ./js/sagas/actions.js